/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 * @packageDocumentation
 */

import { PmcMessageType } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

/**
 * Allow the Signage to refresh it's content.
 * @todo move members to {@link module:Platform~PlayerAbstract} once
 *       {@link module:Platform.BrightSignPlayer} implements it.
 */
export interface ReloadInterface {
    /**
     * **Feature:** Reload the Signage program
     * (Will change to current Signage version if required).
     */
    reloadSignage(): void | Promise<void>;
}

export function supportsReload(platform: unknown): platform is ReloadInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PmcMessageType.ReloadSignage);
    }

    return platform instanceof Object && 'reloadSignage' in platform;
}
